// PERFORMANCE OPTIMIZATION ADDED - Code splitting with React.lazy for better bundle size
import React, { lazy } from "react";

// PERFORMANCE OPTIMIZATION ADDED - Lazy load all page components to reduce initial bundle size
const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const Mangoes = lazy(() => import("../pages/Mangoes"));
const Gallery = lazy(() => import("../pages/Gallery"));
const Contact = lazy(() => import("../pages/Contact"));
const ProductDetail = lazy(() => import("../pages/ProductDetail"));
const Account = lazy(() => import("../pages/Account"));
const AdminLogin = lazy(() => import("../pages/AdminLogin"));
const CancellationRefunds = lazy(() => import("../pages/CancellationRefunds"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));
const Shipping = lazy(() => import("../pages/Shipping"));
const Privacy = lazy(() => import("../pages/Privacy"));
const Blog = lazy(() => import("../pages/Blog"));
const BlogPost = lazy(() => import("../pages/BlogPost"));
const LocationDelivery = lazy(() => import("../pages/LocationDelivery"));
const VerifyEmail = lazy(() => import("../pages/VerifyEmail"));

export interface PublicRouteConfig {
  path: string;
  element: React.ReactElement;
}

export const publicRoutes: PublicRouteConfig[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/mangoes", element: <Mangoes /> },
  { path: "/mangoes/:id", element: <ProductDetail /> },
  { path: "/gallery", element: <Gallery /> },
  { path: "/contact", element: <Contact /> },
  { path: "/login", element: <Account /> },
  // Additive auth aliases — same Account page, friendlier external links / SEO.
  // /login remains the canonical route used by AuthContext, password-reset emails, etc.
  { path: "/register", element: <Account /> },
  { path: "/forgot-password", element: <Account /> },
  // Landing page for the email-verification link sent on registration.
  // Reads ?oobCode=... from the query, applies it via Firebase Auth, and
  // syncs the user's Firestore status. See pages/VerifyEmail.tsx.
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/admin-login", element: <AdminLogin /> },
  { path: "/cancellation-refunds", element: <CancellationRefunds /> },
  { path: "/terms-and-conditions", element: <TermsAndConditions /> },
  { path: "/shipping", element: <Shipping /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogPost /> },
  { path: "/mangoes-delivery-delhi", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-mumbai", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-meerut", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-chandigarh", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-ambala", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-kolkata", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-chennai", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-ahmedabad", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-jaipur", element: <LocationDelivery /> },
  { path: "/mangoes-delivery-lucknow", element: <LocationDelivery /> },
  // Scalable dynamic city route — works for any future city without a router edit.
  { path: "/mangoes-delivery/:city", element: <LocationDelivery /> },
];


